export default __webpack_public_path__ + "static/media/3-friend-icon.bab1271c.svg";